jQuery(function() {

	/**
	 * ドロワーメニュー
	 */
	(function() {

		var $targetParent = jQuery('.footer-nav'); //固定サイドメニューの親要素。relative指定
		var $target       = jQuery('.footer-nav__body'); //固定サイドメニュー本体
		var flag          = 0; //ウィンドウのwidth取得、判定のためのフラグ
		var w;             //ウインドウのwidthを格納

		//ドロワーメニューを閉じるボタンを生成
		function createCloseBtn(elm,txt){
			var $closeBtn = jQuery(elm);
			var $closeBtn2 = jQuery(elm);
			$closeBtn.text(txt);
			$closeBtn2.text(txt);
			$target.prepend($closeBtn);
			$target.append($closeBtn2);
		}

		//ウィンドウサイズを判定するためのフラグ
		jQuery(window).on('load resize', function(){

			w = getWindowWidth();

			if (gVar.bp_md < w){
				flag = 1;
			} else {
				flag = 0;
			}

		})

		//ドロワーメニューを閉じるボタンを生成
		createCloseBtn('<li id="drawer-close-open-btn" class="sd-btn"></li>','close');

		//ドロワーメニューを開く
		jQuery(document).on('click', '#drawer-menu-open-btn, #drawer-menu-open-btn', function(){
			jQuery('body').css('overflow','hidden');
			$target.addClass('is-drawer-menu-open');
			jQuery('#drawer-menu-open-btn').addClass('is-fade-out'); //ドロワーメニューを開いているときに隠す
			jQuery('.go-to-top').addClass('is-fade-out'); //ドロワーメニューを開いているときに隠す
		});

		//ドロワーメニューを閉じる
		jQuery(document).on('click', '#drawer-close-open-btn', function(){
			jQuery('body').removeAttr('style');
			$target.removeClass('is-drawer-menu-open');
			jQuery('#drawer-menu-open-btn').removeClass('is-fade-out');
			jQuery('.go-to-top').removeClass('is-fade-out');
		});

		//ウインドウサイズがmd以上の場合(フラグに応じて)サイドメニューを閉じる
		jQuery(window).on('resize', function(){

			if (flag === 1){
				jQuery('body').removeAttr('style');
				$target.removeClass('is-drawer-menu-open');
				jQuery('#drawer-menu-open-btn').removeClass('is-fade-out');
				jQuery('.go-to-top').removeClass('is-fade-out');
			} else {
				return;
			}

		});

	}());

});